import Report_5_0_PDF from './report_5_0_pdf.js';
export default Report_5_0_PDF;
